export const CALENDAR_PERMISSION_CODES = {
  VIEW_SECTION: 'CALENDARIO.VER_SECCION',
  VIEW_OTHERS_TASKS: 'CALENDARIO.VER_TAREAS_DE_OTROS_USUARIOS',
  TASK_DETAIL: 'CALENDARIO.DETALLE_DE_TAREAS',
};
